import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import axios from "axios";
import "element-ui/lib/theme-chalk/index.css";
import VueAwesomeSwiper from "vue-awesome-swiper";
// require styles
import "swiper/dist/css/swiper.css";
Vue.use(VueAwesomeSwiper /* { default global options } */ );
// axios.defaults.baseURL = "https://testapi.jianchejia.com.cn/";
axios.defaults.baseURL = "https://api.jianchejia.com.cn/";
Vue.prototype.$ajax = axios;
Vue.use(ElementUI);
// 引入全局样式
import "./assets/css/global.css";
// 导入字体图标
import "./assets/fonts/iconfont.css";

// import MetaInfo from 'vue-meta-info'
// Vue.use(MetaInfo)


Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");